<template>
  <div>
    <!-- 基本信息 -->
    <baseInfo v-if="isReady" ref="baseInfo" @setInfo="setInfo" :baseInfo="baseInfo" />
    <!-- 保障方案 -->
    <planInfo v-if="isReady" ref="planInfo" :initRiskData="salInsuredRiskInfos" :baseInfo="baseInfo" @priceComputed="priceComputed" @setRiskInfo="setRiskInfo" />
    <!-- 公司选择 -->
    <company v-if="isReady" :step="step" @setInfo="setInfo" @downloadMGUPros="downloadMGUPros" @goInsured="goInsured" />
    <!-- 添加人员清单 -->
    <salInsuredList ref="salInsuredList" v-if="isReady && step===2" :baseInfo="salInsuredInfo" :riskInfos="allRiskInfos" :salInsuredInlist="salInsuredInlist"  @priceComputed="salInsuredPriceComputed"  @saveGroupPremium="saveGroupPremium" />
    <!-- 上传投保资料 -->
    <fileList :files="files" v-if="isReady && step===2" :baseInfo="baseInfo" />
    <div>
      <div class="fix-btn" @click="isShowPlanDetail = true">查看方案详情</div>
      <a-modal :visible="isShowPlanDetail" :width="imgModalWidth" :footer="null" @cancel="isShowPlanDetail = false">
        <img width="100%" :src="require('@/assets/image/premium/medilinkGroupZRY_plan.jpg')" alt="">
        <div class="img-btn">
          <a-button type="primary" ghost icon="plus" @click="scaleImg(true)"></a-button>
          <a-button type="primary" ghost icon="minus" @click="scaleImg(false)"></a-button>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import baseInfo from "./components/base-info.vue";
import planInfo from "./components/plan-info.vue";
import company from "./components/company";
import salInsuredList from "./components/salInsuredList";
import fileList from "./components/file-list.vue";
import moment from "moment";

export default {
  components: {
    baseInfo,
    planInfo,
    company,
    salInsuredList,
    fileList,
  },
  beforeRouteUpdate(to, form, next) {
    console.log(to)
    this.isReady = false
    this.queryOrderDetails(to.query.appQuesNo)
    next()
  },
  data() {
    return {
      isReady: false,
      isShowPlanDetail: false, // 方案详情显示
      step: 1,
      imgModalWidth: 700,
      baseInfo: {
        inquiryInformation: 'quotation_TaMedilinkGroup_' + moment(new Date()).format('YYYYMMDDHHmmss'),
        productCode: "",
        total_mult: 0,
        totalPremium: 0,
      },
      salInsuredInfo: { // 人员清单的试算信息
        inquiryInformation: 'quotation_TaMedilinkGroup_' + moment(new Date()).format('YYYYMMDDHHmmss'),
        totalPremium: 0,
      },
      priceRiskInfo: [], // 投保人数的计划信息， 过滤了有人员的
      salInsuredRiskInfos: [], // 人员清单的计划信息， 过滤了有人员的
      salInsuredInlist: [], // 人员清单信息
      allRiskInfos: [], // 全部的计划信息，包括没有添加人员信息的
      files: {
        uploadedFiles: [],
        downloadFiles: []
      }, // 已上传的文件
    }
  },
  mounted() {
    const { u, p, appQuesNo } = this.$route.query || {}
    this.baseInfo.productCode = p;
    this.baseInfo.appQuesNo = appQuesNo;
    this.baseInfo.webCustomerId = u;
    this.queryOrderDetails(appQuesNo);
  },
  methods: {
    // 子组件emit信息
    setInfo(data) {
      this.baseInfo = {
        ...this.baseInfo,
        ...data
      }
      this.$refs.planInfo.priceComputed();
      if(this.step === 2) {
        this.$refs.salInsuredList.priceComputed()
      }
    },
    // 方案信息
    setRiskInfo(data) {
      console.log(data)
      this.allRiskInfos = this.$lodash.cloneDeep(data);
      if(this.step === 2) {
        this.$refs.salInsuredList.priceComputed()
      }
    },
    // 保费试算
    async priceComputed(data) {
      const { total_mult, riskInfos, shisuan } = data || {}
      const { productCode, effectiveDate, comp  } = this.baseInfo;
      if (!this.baseInfo.productCode || !riskInfos || !data.riskInfos.length || !effectiveDate ) {
        return false;
      }
      this.baseInfo.total_mult = total_mult;
      const params = {
        productCode,
        riskInfos,
        shisuan,
        effectiveDate,
        comp
      };
      await this.$api.getPremiumZHX(params).then(res => {
        const { riskInfos, ...baseInfo } = res.data.content || {};
        this.priceRiskInfo = riskInfos;
        this.baseInfo = {
          ...this.baseInfo,
          ...baseInfo,
        }
      })
    },
    // 人员清单保费试算
    async salInsuredPriceComputed(data) {
      const { total_mult, riskInfos, insList, shisuan } = data || {}
      const { productCode, effectiveDate, comp, companyname } = this.baseInfo;
      if (!this.baseInfo.productCode || !riskInfos || !data.riskInfos.length || !effectiveDate) {
        return false;
      }
      this.salInsuredInfo.total_mult = total_mult;
      const params = {
        productCode,
        riskInfos,
        insList,
        shisuan,
        effectiveDate,
        comp,
        companyname
      };
      await this.$api.getPremiumZHX(params).then(res => {
        const { riskInfos, ...baseInfo } = res.data.content || {};
        this.salInsuredRiskInfos = riskInfos;
        this.salInsuredInlist = insList
        this.salInsuredInfo = {
          ...this.salInsuredInfo,
          ...baseInfo,
        }
      })
    },
    // 保存询价
    async saveGroupPremium() {
        const baseInfo = await this.$refs.baseInfo.validateForm().catch(() => {
          this.$message.error("请输入完整的基本信息");
        });
        if(! baseInfo) {
          return;
        }
        const validate = await this.$refs.salInsuredList.priceComputed(false);
        if(!validate){return}
        this.$store.commit('setLoading', { show: true });
        const params = {
            createDate: moment(new Date()).format('x'), // 编辑的时候会被覆盖掉
            ...this.baseInfo,
            ...this.salInsuredInfo,
            riskInfos: JSON.stringify({
              comp: this.baseInfo.comp,
              riskInfos: this.salInsuredRiskInfos
            }),
            insuerStatus: "2", // 传2 人员清单
            insList: this.salInsuredInlist,
            updataDate: moment(new Date()).format('x'),
        }
        this.$api.saveGroupAFP(params).then(res => {
            const data = res.data || {}
            if (data.returnCode == '00') {
                this.$message.success(data.returnMsg || '成功')
                const {appQuesNo} = data.content || {}
                this.toEditData(appQuesNo)
            }
        }).finally(() => {
          this.$store.commit('setLoading', { show: false });
        })
    },
    // 编辑询价数据
    toEditData(appQuesNo) {
        if(!appQuesNo){return false;}
        if(this.baseInfo.appQuesNo) {
          return true;
        }
        this.queryOrderDetails(appQuesNo)
        this.$router.replace({
            name: 'MedilinkGroupZRY',
            query: {
                ...this.$route.query,
                appQuesNo
            }
        });
    },
    // 链接后有appQuesNo时查询数据预览 同询价管理查询接口
    queryOrderDetails(appQuesNo){
        if(! appQuesNo) {
            this.disabledAll = false;
            this.isReady = true;
            return false;
        }
        this.disabledAll = true;
        this.step = 2;
        const data = {
            appQuesNo,
            productCode: this.baseInfo.productCode
        }
        this.$api.queryMediLinkQuoAFP(data).then(res => {
            const data = res.data || {}
            if (data.returnCode == '00') {
                let { inquiryInformation, riskInfos, insuredList, ...baseInfo } = data.content || {}
                let {comp, riskInfos: riskInfoData }  = riskInfos && JSON.parse(riskInfos) || {}
                this.salInsuredRiskInfos = riskInfoData
                this.salInsuredInlist = insuredList || []
                this.baseInfo = {
                    ...baseInfo,
                    comp,
                    inquiryInformation,
                    effectiveDate: moment(baseInfo.effectiveDate).format('YYYY-MM-DD'),
                    expireDate: moment(baseInfo.expireDate).format('YYYY-MM-DD')
                }
                this.salInsuredInfo = this.$lodash.cloneDeep(this.baseInfo)
                // 试算没有保存人员数据，没有报价
                this.baseInfo.totalPremium = 0;
                this._queryMediLinkQuoAFPFile() // 查询上传的询价资料
            } else {
                this.$message.error(data.returnMsg || '出错了')
            }
        }).finally(() => {
          this.isReady = true;
        })
    },
    // 查询上传的询价资料
    _queryMediLinkQuoAFPFile() {
        this.$api.queryMediLinkQuoAFPFile({inquiryInformation: this.baseInfo.inquiryInformation}).then(res => {
            const data = res.data || {}
            let { fileUrls } = data.content || {}
            fileUrls = fileUrls || [];
            this.files.downloadFiles = []
            this.files.uploadedFiles = []
            fileUrls.forEach(item => {
              if(item.url.indexOf('/sys/') > -1) {
                this.files.downloadFiles.push(item);
              } else {
                this.files.uploadedFiles.push(item);
              }
            })
        })
    },
    // 生成试算报价书
    async downloadMGUPros() {
      const baseInfo = await this.$refs.baseInfo.validateForm().catch(() => {
        this.$message.error("请输入完整的基本信息");
      });
      if(! baseInfo) {
        return;
      }
      // 企业投保信息
      this.baseInfo = {
        ...this.baseInfo,
        ...baseInfo
      }
      const validate = await this.$refs.planInfo.priceComputed(false);
      if(!validate) {
        return;
      }
      this.$store.commit('setLoading', { show: true });
      const params = {
        ...this.baseInfo,
        riskInfos: this.priceRiskInfo
      }
      this.$api.downloadMGUPros(params).then(res => {
        const data = res.data;
        if(data.returnCode == "00") {
          data.content && window.open(data.content, "_blank")
        } else {
          this.$message.error(data.returnMsg);
        }
      }).finally(() => {
        this.$store.commit('setLoading', { show: false });
      });
    },
    // 直接投保
    goInsured() {
      this.step ++;
    },
    // 放大缩小图片
    scaleImg(isPlus) {
      let val = this.imgModalWidth;
      if(isPlus) { // 放大
        val += 20;
        val = Math.min(val, 1000);
      }
      if(!isPlus) { // 缩小
        val -= 20;
        val = Math.max(val, 500);
      }
      this.imgModalWidth = val;
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .card {
  margin-top: 20px;
  .title {
    color: #fff;
    padding: 7px;
    background-color: #020a76;
    border-radius: 20px 0 0 0;
  }
  .ant-btn-link {
    color: #020a76;
  }
  .ant-btn-primary{
    color: #fff;
    background-color: #020a76;
    border-color: #020a76;
    margin: 20px 20px;
  }
}
.img-btn{
  position: fixed;
  bottom: 3rem;
  right: 2rem;
  background-color: #f7f7f7;
  border-radius: 15px;
  .ant-btn {
    margin: 10px 20px;
  }
}
.fix-btn{
  position: fixed;
  bottom: 30%;
  right: 0;
  color: #fff;
  padding: 12px 6px;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  border: 1px solid rgb(254, 143, 45);
  border-right: none;
  background-color: rgb(254, 143, 45);
  margin: 15px 0;
  cursor: pointer;
}
</style>